<template>
  <f7-app :params="f7params">
    <f7-panel v-if="authorized" left cover>
      <f7-view>
        <f7-page>
          <f7-navbar>
            <f7-nav-left v-if="balanceLoad && user.coef">
              <UserInfoItem
                :emoji="`${user.coef.image}`"
                :title="`${user.lastName} ${user.name}`"
                :link-text="`${user.coef.in_hour}$/h (${user.coef.name})`"
              ></UserInfoItem>

              <UserInfoItem
                emoji="💎"
                :title="`${user.balance}$`"
                :link-text="`${user.workedMins % 60}h ${Math.floor(user.workedMins / 60)}min`"
              ></UserInfoItem>
            </f7-nav-left>
          </f7-navbar>

          <div v-if="videoChat.isShow" class="lesson-card-video-chat">
            <div class="lesson-card-video-chat-inner">
              <div class="lesson-card-video-chat-viewer">
                <vue-webrtc
                  ref="webrtc"
                  width="100%"
                  :enable-logs="false"
                  :room-id="videoChat.roomId"
                  :socket-u-r-l="videoChat.socketURL"
                  @joined-room="onJoinedRoom"
                  @left-room="onLeftRoom"
                  @opened-room="onOpenedRoom"
                />
                <f7-preloader v-if="videoChat.loading" color="white"></f7-preloader>
                <!-- <img :src="videoChat.img" class="img-responsive" /> -->
              </div>
            </div>
          </div>

          <f7-block-title large>My consultations</f7-block-title>

          <f7-list class="lesson-list" no-hairlines no-hairlines-between no-chevron>
            <f7-list-item
              v-for="lesson in lessons"
              :key="lesson.id"
              :class="{ 'active-lesson': lesson.id === currentLessonId }"
              link="#"
              @click="startChat(lesson.id)"
            >
              <LessonCard
                :id="lesson.id"
                :user-id="lesson.user.id"
                :start="lesson.start"
                :name="lesson.user.name"
                :avatar="lesson.user.avatar"
                :last-message="
                  lesson.messages && lesson.messages.length
                    ? lesson.messages[lesson.messages.length - 1].text
                    : ''
                "
                :last-message-type="
                  lesson.messages && lesson.messages.length
                    ? lesson.messages[lesson.messages.length - 1].type
                    : ''
                "
              ></LessonCard>
            </f7-list-item>
          </f7-list>

          <f7-block-title large>New Requests</f7-block-title>

          <f7-list class="request-list" no-hairlines no-hairlines-between no-chevron>
            <f7-list-item v-for="request in requests" :key="request.id">
              <RequestCard
                :id="request.id"
                :language-id="request.languageId"
                :level-id="request.levelId"
                :start="request.start"
                :name="request.user.name"
                :avatar="request.user.avatar"
                @accept-request="handleAcceptRequest"
              ></RequestCard>
            </f7-list-item>
          </f7-list>
        </f7-page>
      </f7-view>
    </f7-panel>

    <f7-view v-if="authorized" url="/" main>
      <HelperPanel :categories="categories"></HelperPanel>
    </f7-view>

    <!-- <f7-popup
      id="popup-auth"
      class="popup-auth"
      tablet-fullscreen
      :opened="!authorized"
      :close-by-backdrop-click="false"
      :close-on-escape="false"
    >
      <f7-view>
        <f7-page>
          <img class="logo-icon" src="static/logo-icon.png" alt="Logo" />

          <f7-block-title class="logo" large><b>Real</b>lang</f7-block-title>

          <f7-list class="popup-auth-list" no-hairlines no-hairlines-between>
            <f7-list-input
              label="Email"
              type="email"
              :clear-button="false"
              :error-message-force="!!auth.email.error"
              :error-message="auth.email.error"
              :value="auth.email.value"
              @input="auth.email.value = $event.target.value"
            ></f7-list-input>

            <f7-list-input
              label="Password"
              type="password"
              :clear-button="false"
              :error-message-force="!!auth.password.error"
              :error-message="auth.password.error"
              :value="auth.password.value"
              @input="auth.password.value = $event.target.value"
            ></f7-list-input>
          </f7-list>

          <f7-block class="button-wrapper">
            <f7-button fill large class="custome-large" @click="handleLogIn">
              Sign in
              <f7-preloader v-if="auth.loading" color="white"></f7-preloader>
              <f7-icon v-else f7="arrow_right" color="white" size="21"></f7-icon>
            </f7-button>
          </f7-block>
        </f7-page>
      </f7-view>
    </f7-popup> -->

    <f7-popup
      id="popup-auth"
      class="popup-auth"
      tablet-fullscreen
      :opened="!authorized"
      :close-by-backdrop-click="false"
      :close-on-escape="false"
    >
      <f7-view>
        <f7-page>
          <img slot="fixed" src="static/flower1.svg" alt="alt" class="popup-auth-decor first" />
          <img slot="fixed" src="static/flower2.svg" alt="alt" class="popup-auth-decor second" />
          <img slot="fixed" src="static/flower3.svg" alt="alt" class="popup-auth-decor third" />

          <div class="popup-auth-inner">
            <img class="logo-icon" src="static/logo-icon.png" alt="Logo" />

            <f7-block-title class="logo" large><b>Stillfy</b></f7-block-title>

            <f7-list class="popup-auth-list" no-hairlines no-hairlines-between form>
              <f7-list-input
                label="Email"
                type="email"
                :clear-button="false"
                :error-message-force="!!auth.email.error"
                :error-message="auth.email.error"
                :value="auth.email.value"
                @input="auth.email.value = $event.target.value"
              ></f7-list-input>

              <f7-list-input
                label="Password"
                type="password"
                :clear-button="false"
                :error-message-force="!!auth.password.error"
                :error-message="auth.password.error"
                :value="auth.password.value"
                @input="auth.password.value = $event.target.value"
              ></f7-list-input>

              <f7-block class="button-wrapper">
                <f7-button
                  class="custome-large gradient"
                  type="submit"
                  fill
                  large
                  @click.prevent="handleLogIn"
                >
                  Sign in
                  <f7-preloader v-if="auth.loading" color="white"></f7-preloader>
                  <f7-icon v-else f7="arrow_right" color="white" size="21"></f7-icon>
                </f7-button>
              </f7-block>
            </f7-list>
          </div>
        </f7-page>
      </f7-view>
    </f7-popup>
  </f7-app>
</template>

<script>
import { merge, isEmpty, debounce } from 'lodash';
import { mapState, mapActions, mapMutations } from 'vuex';

import {
  subscribeToTeacherChannel,
  subscribeToUserChannel
} from '@/js/helpers/subscribeToWsChannel.js';
import { requestAction, userAction } from '@/js/helpers/wsActionManager.js';

import validateEmail from '@/js/helpers/validateEmail.js';
import isTokenExpired from '@/js/helpers/isTokenExpired.js';
import removeTokenFromLocalStorage from '@/js/helpers/removeTokenFromLocalStorage.js';
import notify from '@/js/helpers/notify.js';

import routes from '@/js/routes.js';

import RequestCard from '@/components/RequestCard.vue';
import LessonCard from '@/components/LessonCard.vue';
import HelperPanel from '@/components/HelperPanel.vue';
import UserInfoItem from '@/components/UserInfoItem.vue';
import apiRequest from '../js/helpers/apiRequest';

export default {
  name: 'App',

  components: {
    RequestCard,
    LessonCard,
    HelperPanel,
    UserInfoItem
  },

  data() {
    return {
      f7params: {
        name: 'Stillfy',
        theme: 'aurora',
        routes: routes,

        view: {
          animate: false
        },

        panel: {
          closeByBackdropClick: false,
          swipeActiveArea: 600,
          leftBreakpoint: 600
        },

        touch: {
          auroraTouchRipple: true,
          touchRippleElements: '.ripple, .button'
        },

        // serviceWorker: {
        //   path: "/service-worker.js"
        // },

        popup: {
          closeOnEscape: true
        },

        sheet: {
          closeOnEscape: true
        },

        dialog: {
          title: ''
        },

        popover: {
          closeOnEscape: true
        },

        actions: {
          closeOnEscape: true
        }
      },

      auth: {
        loading: false,
        email: { value: '', error: null },
        password: { value: '', error: null }
      },

      videoChat: {
        // img: null,
        isShow: false,
        loading: false,
        roomId: null,
        socketURL: null
      },
      chatLoading: false
    };
  },

  computed: {
    ...mapState({
      appConfig: state => state.appConfig,
      languages: state => state.languages,
      authorized: state => state.auth.authorized,
      user: state => state.user.info,
      balanceLoad: state => state.user.balanceLoad,
      requests: state => state.request.requests,
      lessons: state => state.lesson.lessons,
      currentLessonId: state => state.lesson.currentLessonId,
      lessonsLoad: state => state.lesson.lessonsLoad,
      categories: state => state.categories
    })
  },

  async mounted() {
    if (localStorage.getItem('access_token') && !isTokenExpired()) {
      this.authorizeUser(true);
      await this.getInitialInfo();

      this.languages.forEach(lang => {
        subscribeToTeacherChannel({ langId: lang.id }, res => {
          requestAction(res);
        });
      });

      subscribeToUserChannel({ userId: this.user.id }, res => {
        userAction(res);
      });

      this.$f7.progressbar.hide();
    } else if (localStorage.getItem('access_token') && isTokenExpired()) {
      removeTokenFromLocalStorage();
      await this.$nextTick();
      notify({
        text: 'Your authorization token has expired. Please log in again.'
      });
    }

    // Subscribe to Store Mutations
    this.$store.subscribe(async mutation => {
      switch (mutation.type) {
        case 'lesson/SET_LESSON': {
          this.chatLoading = false;
          this.$f7.views.main.router.navigate(`/chat/${mutation.payload.lesson.id}`);
          break;
        }

        case 'lesson/SET_CURRENT_CHAT_ID': {
          const { id, video } = this.lessons.find(
            lesson => lesson.id === mutation.payload.lessonId
          );

          if (video) {
            this.videoChat.roomId = btoa(`reallang_stream_${id}`);
            this.videoChat.isShow = true;
            this.$nextTick(() => {
              this.$refs.webrtc.join();
            });
            // setTimeout(() => {
            // }, 1000);
          }
          break;
        }

        case 'lesson/FINISH_LESSON': {
          if (mutation.payload.video) {
            this.$refs.webrtc.rtcmConnection.getAllParticipants().forEach(pid => {
              this.$refs.webrtc.rtcmConnection.disconnectWith(pid);
            });

            this.$refs.webrtc.rtcmConnection.attachStreams.forEach(localStream => {
              localStream.stop();
            });

            this.$refs.webrtc.rtcmConnection.closeSocket();

            this.$nextTick(() => {
              this.videoChat.isShow = false;
              this.videoChat.roomId = null;
            });
          }
          break;
        }

        case 'auth/AUTHORIZE_USER': {
          if (this.authorized) {
            await this.getInitialInfo();

            this.languages.forEach(lang => {
              subscribeToTeacherChannel({ langId: lang.id }, res => {
                requestAction(res);
              });
            });

            subscribeToUserChannel({ userId: this.user.id }, res => {
              userAction(res);
            });
          }
          break;
        }

        default:
          break;
      }
    });

    await this.getAppConfig();
    this.videoChat.socketURL = this.appConfig.video_url;
  },

  methods: {
    async getInitialInfo() {
      this.$f7.progressbar.show('pink');

      await Promise.all([this.getUserInfo(), this.getLanguages(), this.getLevels()]);

      return Promise.all([
        this.getRequests(),
        this.getLesson(),
        this.getWordsCategories(),
        this.getQuickPhrases(),
        this.getProofreads()
      ])
        .then(() => {
          this.$f7.progressbar.hide();
        })
        .catch(error => {
          console.log(error);
        });
    },

    async handleAcceptRequest(id) {
      this.chatLoading = true;
      await this.acceptRequest({ id });
      this.chatLoading = false;
    },

    startChat(id) {
      this.$f7.views.main.router.navigate(`/chat/${id}`);
    },

    validate() {
      const errors = {};
      const { email, password } = this.auth;

      // Reset old erorors
      email.error = null;
      password.error = null;

      if (!validateEmail(email.value)) {
        errors.email = 'Please enter correct email.';
      }

      if (!email.value) {
        errors.email = 'Enter email.';
      }

      if (password.value.length < 8) {
        errors.password = 'Password must be at least 8 characters.';
      }

      if (!password.value) {
        errors.password = 'Enter password.';
      }

      if (isEmpty(errors)) {
        return true;
      }

      // Formating
      Object.keys(errors).forEach(error => {
        errors[error] = {
          error: errors[error]
        };
      });

      merge(this.auth.email, errors.email);
      merge(this.auth.password, errors.password);
    },

    async handleLogIn() {
      if (!this.validate()) {
        return;
      }

      try {
        const {
          email: { value: email },
          password: { value: password }
        } = this.auth;

        this.auth.loading = true;
        const token = await this.logIn({ email, password });
        this.auth.loading = false;

        this.auth.email.value = '';
        this.auth.password.value = '';
        this.$f7.popup.close('#popup-auth');
        this.authorizeUser(true);
      } catch (error) {
        if (error.customeError) {
          this.auth.loading = false;
          notify({ text: error.customeError });
        }
      }
    },

    // onJoin() {
    //   this.$refs.webrtc.join();
    // },

    onOpenedRoom(roomId) {
      console.log(roomId, 'opened');
    },

    onJoinedRoom(id) {
      console.log(id, 'joine');
    },

    onLeftRoom(id) {
      console.log(id, 'left');
    },

    // onJoinedRoom: debounce(function() {
    //   console.log('Joined');
    //   const body = new FormData();
    //   body.append('lesson_id', this.currentLessonId);
    //   apiRequest('lesson/start/video', 'POST', body, true);
    // }, 7000),

    ...mapActions({
      getAppConfig: 'getAppConfig',
      logIn: 'auth/logIn',
      getUserInfo: 'user/getUserInfo',

      getLanguages: 'getLanguages',
      getLevels: 'getLevels',

      getWordsCategories: 'helper/getWordsCategories',
      getQuickPhrases: 'helper/getQuickPhrases',

      getRequests: 'request/getRequests',
      acceptRequest: 'request/acceptRequest',

      getLesson: 'lesson/getLesson',

      getProofreads: 'proofread/getProofreads'
    }),

    ...mapMutations({
      authorizeUser: 'auth/AUTHORIZE_USER',
      setUserInfo: 'user/SET_USER_INFO'
    })
  }
};
</script>

<style lang="less">
.popup-auth-decor {
  position: absolute;

  &.first {
    top: 80px;
    right: 50px;
  }

  &.second {
    bottom: 80px;
    right: 50px;
  }

  &.third {
    bottom: 20%;
    left: 50px;
  }
}
</style>
